/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeTriangleALeftIcon16Light } from './ArrowShapeTriangleALeftIcon16Light';
import { ArrowShapeTriangleALeftIcon16Regular } from './ArrowShapeTriangleALeftIcon16Regular';
import { ArrowShapeTriangleALeftIcon16Solid } from './ArrowShapeTriangleALeftIcon16Solid';
import { ArrowShapeTriangleALeftIcon20Light } from './ArrowShapeTriangleALeftIcon20Light';
import { ArrowShapeTriangleALeftIcon20Regular } from './ArrowShapeTriangleALeftIcon20Regular';
import { ArrowShapeTriangleALeftIcon20Solid } from './ArrowShapeTriangleALeftIcon20Solid';
import { ArrowShapeTriangleALeftIcon24Regular } from './ArrowShapeTriangleALeftIcon24Regular';
import { ArrowShapeTriangleALeftIcon24Solid } from './ArrowShapeTriangleALeftIcon24Solid';
import { ArrowShapeTriangleALeftIcon32Regular } from './ArrowShapeTriangleALeftIcon32Regular';
import { ArrowShapeTriangleALeftIcon64Regular } from './ArrowShapeTriangleALeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeTriangleALeftIcon16Light,
        regular: ArrowShapeTriangleALeftIcon16Regular,
        solid: ArrowShapeTriangleALeftIcon16Solid,
    },
    20: {
        light: ArrowShapeTriangleALeftIcon20Light,
        regular: ArrowShapeTriangleALeftIcon20Regular,
        solid: ArrowShapeTriangleALeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeTriangleALeftIcon24Regular,
        solid: ArrowShapeTriangleALeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeTriangleALeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeTriangleALeftIcon64Regular,
    },
};
export var ArrowShapeTriangleALeftIcon = forwardRef('ArrowShapeTriangleALeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
